import { PdfGen, PdfSize, PdfRect, PageGen } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { calcOrigin } from '../../core/genHelper';
import { drawRope } from '../../pdf/board/rope';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/cut';
import '../../pdf/draw/label';

/**
 * Provazek - Rope matching cards (4 variants: 3/4/5/6 items)
 *
 * 2 portrait pages with 5 rope cards each:
 * - Page 0 (front): Images at top, shuffled text labels at bottom, with punch holes
 * - Page 1 (back): Answer key with connection lines, plus window for threading
 *
 * Students thread a rope through holes to match images with labels.
 *
 * Migrated from C# EduFrame.Img10.Generators.RopeBase + DrawRope + Provazek__3/4/5/6
 */

function generateProvazek(itemCount: number) {
  return async (pdf: PdfGen, opts: OptsLabel): Promise<void> => {
    const totalItems = opts.list.length;
    const cardsPerSet = 5;
    const rnd = opts.data.random;

    for (let i = 0; i < totalItems; i += cardsPerSet) {
      const page0 = pdf.addPage();
      const page1 = pdf.addPage();

      const { origin, size } = calcOrigin(1, cardsPerSet, 0, PdfSize.A4);
      const currentCards = opts.list.slice(i, i + cardsPerSet);

      for (let y = 0; y < currentCards.length; y++) {
        const rect = new PdfRect(origin.x, origin.y + y * size.height, size.width, size.height);

        // For each card, we need 'itemCount' items to match
        // Shuffling the whole list to pick random items for each card
        const shuffled = [...opts.list];
        for (let p = shuffled.length - 1; p > 0; p--) {
          const j = rnd.next(0, p + 1);
          [shuffled[p], shuffled[j]] = [shuffled[j], shuffled[p]];
        }
        const cardItems = shuffled.slice(0, itemCount);
        const map = [...Array(cardItems.length).keys()];

        drawRope(page0, page1, rect, cardItems, map, rnd, true);
      }
    }
  };
}

export class Provazek__3 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 50;
  }
  public generate = generateProvazek(3);
}

export class Provazek__4 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 50;
  }
  public generate = generateProvazek(4);
}

export class Provazek__5 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 50;
  }
  public generate = generateProvazek(5);
}

export class Provazek__6 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 50;
  }
  public generate = generateProvazek(6);
}
